import { jsx as _jsx } from "react/jsx-runtime";
import { CanvasFrameContext } from './canvasFrame.js';
import { CanvasLayerIndexProvider, WORLD_CANVAS_LAYER } from './lighting2d/canvasItemPlacement.js';
export function ViewportCanvasScope({ children }) {
    return (_jsx(CanvasLayerIndexProvider, { value: WORLD_CANVAS_LAYER, children: _jsx(CanvasFrameContext.Provider, { value: null, children: children }) }));
}
//# sourceMappingURL=viewportCanvasScope.js.map